module.exports = __webpack_public_path__ + "static/img/Felipe-Heusser.fa5bbdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/speakers/avatar/Felipe-Heusser.png
// module id = 598
// module chunks = 1